export default "__VITE_PUBLIC_ASSET__387d1962__"